import { Link } from "@mui/material";
import { SPP_GUIDE_LINK } from "@covertree/consts";

export const SPPGuideLink = (
  <Link
    href={SPP_GUIDE_LINK}
    target="_blank"
    underline="hover"
    rel="noopener noreferrer">
    Scheduled Personal Property guide
  </Link>
);
